import { render, staticRenderFns } from "./CompanyProfileCard.vue?vue&type=template&id=3fdf721c&scoped=true&"
import script from "./CompanyProfileCard.vue?vue&type=script&lang=js&"
export * from "./CompanyProfileCard.vue?vue&type=script&lang=js&"
import style0 from "./CompanyProfileCard.vue?vue&type=style&index=0&lang=css&"
import style1 from "./CompanyProfileCard.vue?vue&type=style&index=1&id=3fdf721c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fdf721c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VImg } from 'vuetify/lib/components/VImg';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VCol,VImg,VRow})
